import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-999931fc")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("button", {
    class: "uk-button button--thoth",
    style: _ctx.buttonStyle,
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.actionOnClick && _ctx.actionOnClick(...args))),
    disabled: _ctx.disabled,
    type: "button"
  }, _toDisplayString(_ctx.text), 13, ["disabled"]))
})